'use client'

import { cn } from '@/services/utils/cn'
import React, { useState } from 'react'

interface ChipProps {
  name: string
  className?: string
  activeColor?: string
  inactiveColor?: string
  static?: boolean
  initiallyActive?: boolean
  hasDropShadow?: boolean
  onClick?: () => void // Add the onClick prop
}

export function Chip({
  name,
  className = '',
  activeColor = 'bg-blue-500 text-white',
  inactiveColor = 'border border-black bg-white text-black',
  static: isStatic = false,
  initiallyActive = false,
  hasDropShadow = true,
  onClick, // Include onClick here
}: ChipProps) {
  const [isActive, setIsActive] = useState(initiallyActive)

  const handleClick = () => {
    if (!isStatic) {
      setIsActive((prev) => !prev)
      if (onClick) onClick() // Trigger the onClick callback if provided
    }
  }

  return (
    <div
      className={cn(
        `mt-2 h-min w-auto cursor-pointer gap-2 whitespace-nowrap rounded-full px-2 py-1 text-sm leading-none`,
        hasDropShadow ? 'shadow-md' : '',
        isActive ? activeColor : inactiveColor,
        isStatic ? 'cursor-default' : '',
        className
      )}
      onClick={handleClick} // Attach the click handler
    >
      {name}
    </div>
  )
}
